import React from "react";
import ChipInput from 'material-ui-chip-input'
import Chip from '@material-ui/core/Chip';

export const ChipsType = ({ data, onChange, title }) => (
  <ChipInput
    defaultValue={data}
    onChange={(chips) => onChange(chips)}
    variant="outlined"
    fullWidth
    label={title}
    chipRenderer={({ value, text, chip, isFocused, isDisabled, isReadOnly, handleClick, handleDelete, className }, key) =>
      <Chip key={key} label={text} onDelete={handleDelete} color="primary" style={{ marginRight: 3 }} />
    }
  />
);
